import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Login from '@/components/Login'
import Register from '@/components/Register'
import UpdatePassword from '@/components/UpdatePassword'
import Apps from '@/components/Apps'
import SuperSignApps from '@/components/SuperSignApps'
import AppInfo from '@/components/AppInfo'
import AppEdit from '@/components/AppEdit'
import AppPreviewResource from '@/components/AppPreviewResource'
import AppMerge from '@/components/AppMerge'
import Pricing from '@/components/Pricing'
import SuperSignPricing from '@/components/SuperSignPricing'
import Order from '@/components/Order'
import SignOnline from '@/components/SignOnline'
import AutoSignManager from '@/components/AutoSignManager'
import Identify from '@/components/Identify'
import MobielConfigApp from '@/components/MobielConfigApp'
import MakeMobielConfigAppWindow from '@/components/MakeMobielConfigAppWindow'
import  AppDownloadCode from '@/components/AppDownloadCode'
import SuperSignAppUploadWindow from '@/components/SuperSignAppUploadWindow'
import AppleDeveloperAccount from '@/components/AppleDeveloperAccount'
import AppAppleDeveloperAccount from '@/components/AppAppleDeveloperAccount'
import SuperSign from '@/components/SuperSign'
import ESign from '@/components/ESign'
import Fenfa from '@/components/Fenfa'
import ForgetPassword from '@/components/ForgetPassword'

Vue.use(Router)

const router = new Router({
    routes: [
        {
        path: '/',
        name: 'index',
        component: SuperSignApps
        },  
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/register',
            name: 'register',
            component: Register
        },
        {
            path:'/update/password',
            name:'UpdatePassword',
            component:UpdatePassword
        },
        {
            path:'/forgetPassword',
            name:'ForgetPassword',
            component:ForgetPassword
        },
        // {
        //     path: '/apps',
        //     name: 'apps',
        //     component: Apps,
        // },
        {
            path: '/superSignApps',
            name: 'SuperSignApps',
            component: SuperSignApps,
        },
        {
            path:'/app/mobielconfig',
            name:'MobielConfigApp',
            component:MobielConfigApp
        },
        {
            path:'/app/mobielconfig/make',
            name:'MakeMobielConfigAppWindow',
            component:MakeMobielConfigAppWindow
        },
        {
            path: '/pricing',
            name: 'Pricing',
            component: Pricing,
        },
        {
            path: '/superSignPricing',
            name: 'SuperSignPricing',
            component: SuperSignPricing,
        },
        {
            path: '/order',
            name: 'Order',
            component: Order,
        },
        {
            path: '/apps/:shortLink',
            component: AppInfo,
            children: [
                {
                    path: '',
                    name: 'AppEdit',
                    component: AppEdit,
                },
                {
                    path: 'preview',
                    name: 'AppPreviewResource',
                    component: AppPreviewResource,
                },
                {
                    path: 'merge',
                    name: 'AppMerge',
                    component: AppMerge,
                },
                {
                    path:'downloadCode',
                    name:'AppDownloadCode',
                    component:AppDownloadCode
                },
                {
                    path:'bindAppleDeveloperAccouts',
                    name:'AppAppleDeveloperAccount',
                    component:AppAppleDeveloperAccount
                },
            ]
        },
        {
            path: '/sign/online',
            name: 'SignOnline',
            component: SignOnline,
        },
        {
            path: '/sign/manager',
            name: 'AutoSignManager',
            component: AutoSignManager
        },
        {
            path: '/identify',
            name: 'Identify',
            component: Identify,
        },
        {
            path:'/appleDeveloperAccount/manager',
            name:'AppleDeveloperAccount',
            component:AppleDeveloperAccount,
        },
        {
            path:'/superSign',
            name:'SuperSign',
            component:SuperSign
        },
        {
            path:'/e-sign',
            name:'ESign',
            component:ESign
        },
        {
            path:'/fenfa',
            name:'Fenfa',
            component:Fenfa
        }
    ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js